import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { Layout, Drawer, Button, Dropdown, Menu } from "antd";
import { useMedia } from "react-use";
import { FaFilter } from "react-icons/fa";

import SearchPanel from "../../components/searchpanel";
import MasonryList from "../../components/masonrylist";

import { LanguageState } from "../../reducers/language";
import { AuthState } from "../../reducers/auth";
import { FiltersState } from "../../reducers/filters";
import { ItemsState } from "../../reducers/items";
import { State, Entities } from "../../interfaces";

// import { useWhyDidYouUpdate } from "../../hooks/useWhyDidYouUpdate";

import "rc-drawer/assets/index.css";
import domain from "../../utils/domain";
import DynamicIcon from "../../components/DynamicIcon";

const { Content, Header } = Layout;

const sidebar = (
  <div className="search-panel">
    <SearchPanel />
  </div>
);

interface Props {}

const Home: React.FC<Props> = (props) => {
  // useWhyDidYouUpdate("Home", props);
  const auth: AuthState = useSelector(
    (state: State) => state.auth,
    shallowEqual
  );

  const filters: FiltersState = useSelector(
    (state: State) => state.filters,
    shallowEqual
  );
  const { isLoading: isLoadingFilters } = filters;

  const language: LanguageState = useSelector(
    (state: State) => state.language,
    shallowEqual
  );
  const { labels } = language;

  const typologies = useSelector(
    (state: State) => state.filters.typologies,
    shallowEqual
  );

  const typeEntities: Entities = typologies.entities;

  const items: ItemsState = useSelector(
    (state: State) => state.items,
    shallowEqual
  );
  const { entities, total } = items;

  const [open, setOpen] = useState(false);
  const isSmall = useMedia("(max-width: 768px)");

  const onClose = () => {
    setOpen(false);
  };

  const onToggleMenu = () => {
    setOpen((open) => !open);
  };

  const getAddBtns = () => {
    return (
      <Menu>
        {typeEntities.all.map((_id: string) => {
          const { id, name, icon } = typeEntities.byId[_id];
          // const link = `${domain}node/add/item/?accesToken=${auth.accessToken}`;
          const link = `${domain}node/add/item/?type=${id}&at=${auth.accessToken}`;
          return (
            <Menu.Item key={id}>
              <a href={link} target="_blank" rel="noopener noreferrer">
                <div className="add-item-link">
                  {name} <DynamicIcon type={icon} />
                </div>
              </a>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  return (
    <>
      <Layout className="main-layout">
        <Content className={"gallery " + (isSmall ? "gallery-mobile" : "")}>
          {labels && (
            <Header
              className={"grid-header " + (isSmall ? "grid-header-mobile" : "")}
            >
              {isSmall && ( // mobile of search panel
                <Button className="menu-btn" onClick={onToggleMenu}>
                  <FaFilter />
                </Button>
              )}
              <span style={{ flex: 1 }}>
                {entities.all.length}/{total} {labels.itemsFound}
              </span>
              <Dropdown
                className="add-item"
                overlay={getAddBtns()}
                trigger={["click"]}
              >
                <Button className="ant-dropdown-link">
                  <PlusOutlined /> Add Asset <DownOutlined />
                </Button>
              </Dropdown>
            </Header>
          )}
          {labels && !isLoadingFilters && <MasonryList labels={labels} />}
          {/* {showShareModal && <ShareModal />}
          {showEditModal && <EditModal />} */}
        </Content>
      </Layout>
      <Drawer
        className={isSmall ? "mobile" : "desktop"}
        style={{ overflow: "auto" }}
        getContainer=".main-layout"
        mask={isSmall}
        closable={false}
        placement="left"
        visible={open || !isSmall}
        width={250}
        maskClosable={isSmall}
        onClose={onClose}
      >
        {sidebar}
      </Drawer>
    </>
  );
};

export default Home;
